<template>
  <div class="wrap">
    <div class="con">
      <div class="left-templet">
        <ul>
          <li class="pointer" @click="page = 1" :class="{'on' : page === 1}">
            <a>페이지 순서</a>
          </li>
          <li class="pointer" @click="page = 2" :class="{'on' : page === 2}">
            <a>신청 개요 / Access Code</a>
          </li>
          <li class="pointer" @click="page = 3" :class="{'on' : page === 3}">
            <a>신청 동의</a>
          </li>
          <li class="pointer" @click="page = 4" :class="{'on' : page === 4}">
            <a>신청 안내 페이지</a>
          </li>
          <li class="pointer" @click="page = 5" :class="{'on' : page === 5}">
            <a>프로그램 등록</a>
          </li>
          <li class="pointer" @click="page = 6" :class="{'on' : page === 6}">
            <a>학습자 정보 입력</a>
          </li>
          <li class="pointer" @click="page = 7" :class="{'on' : page === 7}">
            <a>결제 페이지</a>
          </li>
          <li class="pointer" @click="page = 8" :class="{'on' : page === 8}">
            <a>팝업 설정</a>
          </li>
          <li class="pointer" @click="page = 9" :class="{'on' : page === 9}">
            <a>신청내역 확인 페이지</a>
          </li>
          <li class="pointer" @click="page = 10" :class="{'on' : page === 10}">
            <a>신청 완료 시 알림 톡</a>
          </li>
          <li class="pointer" @click="page = 11" :class="{'on' : page === 11}">
            <a>대기자로 등록 시</a>
          </li>
          <li class="pointer" @click="page = 12" :class="{'on' : page === 12}">
            <a>프로그램 추가</a>
          </li>
        </ul>
      </div>
      <div class="guide-slider-wrap dp-inblock w-85per">
        <!-- 1페이지 -->
        <div class="guide-slider" v-show="page === 1">
          <h2>페이지 순서</h2>
          <h3 class="preline txt-red font-14">
            <br>
            * 체크된 페이지만 노출 <br>
            ** 페이지 순서 및 순서는 한번 저장하면 수정할 수 없으니 신중히 선택!
          </h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>페이지 제목을 20자 이내로 입력 (학습자에게 노출)</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>3가지 유형 중 원하는 페이지의 순서 선택</p>
            </li>
            <li>
              <span class="number">3</span>
              <p>체크 박스 선택하여 노출할 페이지 선택</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-01.png" alt="guide">
          </div>
        </div>

        <!-- 2페이지 -->
        <div class="guide-slider" v-show="page === 2">
          <h2 class="mb-20">수강신청 개요 / Access Code 입력</h2>
          <h3 class="preline">
            수강신청을 위한 Access Code 입력 페이지 및 기본 수강신청 개요 입력 페이지 입니다.
          </h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>과정 문의 담당자로 등록된 담당자는 연락처 및  메일이 수강신청 페이지에 노출 <br><b style="font-weight: normal; font-size: 14px; color:fe0000;">* 1:1 문의 등 알림톡은 HQ매니저에게만 발송</b></p>
            </li>
            <li>
              <span class="number">2</span>
              <p>페이지의 포인트 컬러 선택 가능 <br><b style="font-weight: normal; font-size: 14px; color:fe0000;">* 최대한 고객사 컬러에 맞춰 지정</b></p>
            </li>
            <li>
              <span class="number">3</span>
              <p>수강 신청 페이지 입장 전 주요 안내 문구 등록 (‘기본 문구 삽입’ 클릭 시 예시 사용 가능) </p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-02.jpg" alt="guide">
          </div>

          <h3 class="preline">
          </h3><br>

          <h2>신청자 수 제한</h2>
          <ul>
            <li>
              <span class="number">1</span>
              <p>제한 없음이란? <br><b style="font-weight: normal; font-size: 14px;">전체 과정 제한 없이 전 학습자 신청 가능할 경우</b></p>
            </li>
            <li>
              <span class="number">2</span>
              <p>프로그램 선착순 제한란? <br><b style="font-weight: normal; font-size: 14px;">프로그램 자체의 선착순 제한 및 대기자 설정 가능 <br>
                예) 과정 유형 관계없이 일괄 접수 후 분반 경우</b></p>
            </li>
            <li>
              <span class="number">3</span>
              <p>과정 별 선착순 제한이란?<br><b style="font-weight: normal; font-size: 14px;">‘프로그램 등록 페이지’ 에서 총 인원 및 대기자 수 지정 가능  <br>*프로그램 등록 페이지 참고*</b> </p>
            </li>
          </ul>

          <div class="guide-img">
            <img src="@/assets/img/guide-03.jpg" alt="guide">
          </div>
        </div>

        <!-- 3페이지 -->
        <div class="guide-slider" v-show="page === 3">
          <h2 class="mb-20">신청 동의</h2>
          <h3 class="preline">
            수강신청 전 학습자가 반드시 확인 해야 하는 규정을 등록하는 페이지입니다.
            규정에 반드시 동의해야 수강신청이 가능합니다.
          </h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>20자 내외의 수강신청 규정 제목 입력</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>수강 신청 규정은 최대 5개까지 가능 </p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-04.jpg" alt="guide">
          </div>
        </div>

        <!-- 4페이지 -->
        <div class="guide-slider" v-show="page === 4">
          <h2 class="mb-20">신청 안내 페이지(매니저)</h2>
          <h3 class="preline">
            수강신청 전 페이지에 수강에 대한 설명/출결관리기준 등 안내사항을 보여주는 페이지입니다.
          </h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>수강 신청 전, 주요 안내 문구 등록 (수료기준, 과정 소개, 우수 학습자,..)</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>기본 문구 클릭 시 ‘기본 문구‘ 입력 및 수정 가능</p>
            </li>
            <li>
              <span class="number">3</span>
              <p>이미지로 업로드 가능</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-05.jpg" alt="guide">
          </div>

          <h3 class="preline">
          </h3><br>

          <h2>신청 안내 페이지 (학습자)</h2>
          <ul>
            <li>
              <span class="number">1</span>
              <p>학습자 페이지(예시)</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-06.jpg" alt="guide">
          </div>

        </div>

        <!-- 5페이지 -->
        <div class="guide-slider" v-show="page === 5">
          <h2 class="mb-20">프로그램 등록</h2>
          <h3 class="preline"></h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>검색 노출 여부란?</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>클래스 중복 신청<br>
                <b style="font-weight: normal; font-size: 14px;">
                  1) 중복 가능 : 과정 유형 관계 없이 중복 신청 가능 <br>
                  2) 과정 내 중복 가능/타과정 중복 불가능 : 1개의 탭에서만 다수 클래스 중복 가능 (예 : 영어 탭 내에서만 중복 신청 가능) <br>
                  3) 과정 내 불가/타과정 중복 가능 : 탭 당 1개 클래스만 신청 가능 (예 :영어1개, 일본어 1개)
                </b>
              </p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-07.jpg" alt="guide">
          </div>

          <h3 class="preline">
          </h3><br>

          <ul>
            <li>
              <span class="number">1</span>
              <p>검색 노출 여부란?<br>
                <b style="font-weight: normal; font-size: 14px; color: #fe0000;">
                  * ‘클래스 전체 선착순’ 클릭 시 한 탭의 전체 선착순 및 대기자 체크 가능 ** ‘클래스 별 선착순’ 클릭 시 행 ‘우측’에 선착순/대기자 숫자 기재 가능
                </b>
              </p>
            </li>
            <li>
              <span class="number">2</span>
              <p>탭(=과정)이 1개 일 경우 학습자 단에 탭이 노출되지 않으며,‘탭 추가’  2개이상 일 시 학습자단탭 노출</p>
            </li>
            <li>
              <span class="number">3</span>
              <p>행을 드래그하여 순서 변경 가능하며 삭제/추가 클릭 시 행 삭제/추가 가능</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-08.jpg" alt="guide">
          </div>

        </div>

        <!-- 6페이지 -->
        <div class="guide-slider" v-show="page === 6">
          <h2 class="mb-20">학습자 정보 입력</h2>
          <h3 class="preline"></h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>수강신청 내역확인을 위해 이름, 비밀번호, E-mail은 필수 입니다.</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>수강 신청 내역 확인 위해 이름, 비밀번호, 이메일 입력 필수. 외 필요 항목은 체크 박스에 체크</p>
            </li>r
            <li>
              <span class="number">3</span>
              <p>옵션 선택 시 직접 작성 가능 (옵션 입력 후 좌측 체크박스 표시 필수)</p>
            </li>
            <li>
              <span class="number">4</span>
              <p>옵션 입력 시 학습자 페이지에서 확인 가능</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-09.jpg" alt="guide">
          </div>
        </div>

        <!-- 7페이지 -->
        <div class="guide-slider" v-show="page === 7">
          <h2 class="mb-20">결제 페이지</h2>
          <h3 class="preline"></h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>결제 방법 선택에 따라 실시간 계좌이체/ 카드결제/ 부분결제 (교재비와 수업비를 학습자가 선택하여 결제)가 가능</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>면세(전화영어) / 과세 (글로벌 과정은 VAT 10%V 반영 금액 필수)</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-10.jpg" alt="guide">
          </div>
        </div>

        <!-- 8페이지 -->
        <div class="guide-slider" v-show="page === 8">
          <h2 class="mb-20">팝업 설정</h2>
          <h3 class="preline"></h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>수강 신청 페이지 진입 시 팝업 설정 가능 (이미지 가로 값은 400px 이내) 예시 ) 수강 신청 시 강조해야 할 유의사항</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>학습자단 예시 페이지</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-11.jpg" alt="guide">
          </div>
        </div>

        <!-- 9페이지 -->
        <div class="guide-slider" v-show="page === 9">
          <h2 class="mb-20">신청내역 확인 페이지</h2>
          <h3 class="preline"></h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>수강 신청 제작 시, 수강 신청 개요 페이지 탭에 신청 내역 확인 버튼 자동 생성 </p>
            </li>
            <li>
              <span class="number">2</span>
              <p>사용자가 신청 시 입력했던 Email 및 비밀번호 통해 신청내역 확인 가능</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-12.jpg" alt="guide">
          </div>
        </div>

        <!-- 10페이지 -->
        <div class="guide-slider" v-show="page === 10">
          <h2 class="mb-20">신청 완료 시 알림 톡</h2>
          <h3 class="preline"></h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>신청 완료 시 ‘신청완료 안내’ 메일 자동 안내</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>카톡 알림 <br> 신청자 정보 내 휴대전화번호 체크 박스 선택 시‘알림 톡’ 받음 </p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-13.jpg" alt="guide">
          </div>
        </div>

        <!-- 11페이지 -->
        <div class="guide-slider" v-show="page === 11">
          <h2 class="mb-20">대기자로 등록 시</h2>
          <h3 class="preline"></h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>대기자로 신청 시 신청결과에 ‘대기자’로 명시되며 ‘대기자 등록‘관련 이메일 및 알림톡X</p>
            </li>
            <li>
              <span class="number">2</span>
              <p>기존 학습자가 취소할 경우 : 자동으로대기자에게 ‘신청완료’ 이메일 및 알림톡 O</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-14.jpg" alt="guide">
          </div>
        </div>

        <!-- 12페이지 -->
        <div class="guide-slider" v-show="page === 12">
          <h2 class="mb-20">프로그램 추가</h2>
          <h3 class="preline">
            원하는 프로그램의  복사본의 복사 버튼 클릭 통해 복사본 생성 가능 즉, 기존 프로그램을 세분화하는 기능 <br>
            * 추가 된 프로그램은 수강신청의 기간에 따르며, 다르게 설정 불가 (변경 시 모든 프로그램에 적용)
          </h3>
          <ul>
            <li>
              <span class="number">1</span>
              <p>프로그램만 복사 : 기존 프로그램과 동일 하나 프로그램 등록 내  탭 존재 X </p>
            </li>
            <li>
              <span class="number">2</span>
              <p>프로그램 내부 전체 복사 : 기존 프로그램과 동일 및 기존 탭 유지 O</p>
            </li>
          </ul>
          <div class="guide-img">
            <img src="@/assets/img/guide-15.jpg" alt="guide">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    page: 1
  })
}
</script>
